// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  box-sizing: border-box;
  height: var(--header-height);
  width: 100%;
  z-index: var(--z-index-header);
  background-color: var(--white-color-lightest);
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: var(--white-color-dark) 1px solid;
}
.header .header-container {
  flex: 1 1;
  height: 100%;
  max-width: 2000px;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/Header.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,4BAAA;EACA,WAAA;EACA,8BAAA;EACA,6CAAA;EACA,kBAAA;EACA,mBAAA;EACA,gDAAA;AACJ;AACI;EACE,SAAA;EACA,YAAA;EACA,iBAAA;AACN","sourcesContent":[".header {\r\n    box-sizing: border-box;\r\n    height: var(--header-height);\r\n    width: 100%;\r\n    z-index: var(--z-index-header);\r\n    background-color: var(--white-color-lightest);\r\n    padding-left: 16px;\r\n    padding-right: 16px;\r\n    border-bottom: var(--white-color-dark) 1px solid;\r\n\r\n    .header-container{\r\n      flex: 1;\r\n      height: 100%;\r\n      max-width: 2000px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
